import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
})
export class TruncatePipe implements PipeTransform {

  transform(text:string, length:number) {
    var b = 0;
    for (var i=0; i<text.length; i++) {
        b += text.charCodeAt(i) <= 255 ? 1 : 2;
        if (b > length) {
            return text.substr(0, i) + '…';
        }
    }
    return text;
  }
}


// WEBPACK FOOTER //
// ./src/pipes/truncate/truncate.ts